import { render, staticRenderFns } from "./NewWebsite.vue?vue&type=template&id=19090d74&scoped=true&"
import script from "./NewWebsite.vue?vue&type=script&lang=js&"
export * from "./NewWebsite.vue?vue&type=script&lang=js&"
import style0 from "./NewWebsite.vue?vue&type=style&index=0&id=19090d74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19090d74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19090d74')) {
      api.createRecord('19090d74', component.options)
    } else {
      api.reload('19090d74', component.options)
    }
    module.hot.accept("./NewWebsite.vue?vue&type=template&id=19090d74&scoped=true&", function () {
      api.rerender('19090d74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Wizard/StepOne/NewWebsite.vue"
export default component.exports